module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks#toc_marker-1"
    }
  }, [_vm._v("Blood on the Tracks")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks1#toc_marker-2"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/#toc_marker-3"
    }
  }, [_vm._v("Contents")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks3#toc_marker-4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks4#toc_marker-5"
    }
  }, [_vm._v("The Man with the Watches")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Arthur Conan Doyle")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks5#toc_marker-6"
    }
  }, [_vm._v("The Mystery of Felwyn Tunnel")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("L. T. Meade and Robert Eustace")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks6#toc_marker-7"
    }
  }, [_vm._v("How He Cut His Stick")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Matthias McDonnell Bodkin")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks7#toc_marker-8"
    }
  }, [_vm._v("The Mysterious Death on the Underground Railway")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Baroness Orczy")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks8#toc_marker-9"
    }
  }, [_vm._v("The Affair of the Corridor Express")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Victor L. Whitechurch")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks9#toc_marker-10"
    }
  }, [_vm._v("The Case of Oscar Brodski")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("R. Austin Freeman")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks10#toc_marker-11"
    }
  }, [_vm._v("The Eighth Lamp")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Roy Vickers")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks11#toc_marker-12"
    }
  }, [_vm._v("The Knight’s Cross Signal Problem")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Ernest Bramah")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks12#toc_marker-13"
    }
  }, [_vm._v("The Unsolved Puzzle of the Man with No Face")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Dorothy L. Sayers")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks13#toc_marker-14"
    }
  }, [_vm._v("The Railway Carriage")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("F. Tennyson Jesse")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks14#toc_marker-15"
    }
  }, [_vm._v("Mystery of the Slip-Coach")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Sapper")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks15#toc_marker-16"
    }
  }, [_vm._v("The Level Crossing")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Freeman Wills Crofts")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks16#toc_marker-17"
    }
  }, [_vm._v("The Adventure of the First-Class Carriage")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Ronald Knox")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks17#toc_marker-18"
    }
  }, [_vm._v("Murder on the 7.16")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Michael Innes")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks18#toc_marker-19"
    }
  }, [_vm._v("The Coulman Handicap")]), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "apple-tab-span"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Michael Gilbert")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks19#toc_marker-20"
    }
  }, [_vm._v("More from this Author")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks20#toc_marker-21"
    }
  }, [_vm._v("Contact Us")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55018410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Blood_on_the_Tracks-2.vue
// module id = 66
// module chunks = 0